import dayjs from "dayjs";

const generateTimeSheetData = () => {
  const startDate = dayjs("2023-01-05"); // Starting from Jan 5th
  const endDate = dayjs();

  const activities = [];

  // Generate random number of activities (between 30-50)
  const numberOfActivities = Math.floor(Math.random() * 20) + 30;

  const activityTitles = ["Green Card", "Visa", "Work from home"];

  const activityDescriptions = [
    "I-485 has been added by richa@tektreeinc.com",
    "Status hase been changed from [ Draft ] to [ Approved ] by EMAIL",
    "I-140 Document [Screenshot 20200323 at 9.57.15 PM.png] has been added by richa@tektreeinc.com",
  ];

  const fullDescription = [
    "A description example is a sample or illustration of how something is described, often using words to create a vivid image in the reader's mind. It can be a statement, a piece of writing, or even a visual representation that captures the characteristics of a person, place, thing, or idea.",
    "",
  ];

  const employeeDetails = [
    {
      name: "Richa Sarkar",
      email: "richa@tektreeinc.com",
      employeeId: "EMP-1041",
    },
    {
      name: "Shruti Seth",
      email: "shruti@tektreeinc.com",
      employeeId: "EMP-1042",
    },
    {
      name: "Kiran ",
      email: "kiran@tektreeinc.com",
      employeeId: "EMP-1043",
    },
  ];

  // Generate random activities
  for (let i = 0; i < numberOfActivities; i++) {
    // Random date between start and end date
    const daysDiff = endDate.diff(startDate, "day");
    const randomDays = Math.floor(Math.random() * daysDiff);
    const activityDate = startDate.add(randomDays, "day");

    // Random time (8 AM to 6 PM)
    const hour = Math.floor(Math.random() * 10) + 8;
    const minute = Math.floor(Math.random() * 4) * 15; // 0, 15, 30, or 45
    const activityTime = `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}`;

    // Random title and description
    const titleIndex = Math.floor(Math.random() * activityTitles.length);
    const descIndex = Math.floor(Math.random() * activityDescriptions.length);

    activities.push({
      dateTime: `${activityDate.format("YYYY-MM-DD")}T${activityTime}:00Z`,
      title: activityTitles[titleIndex],
      description: activityDescriptions[descIndex],
      employee:
        employeeDetails[Math.floor(Math.random() * employeeDetails.length)],
      fullDescription: fullDescription[descIndex],
    });
  }

  return activities;
};

// Export the function to use it in other components
export const getTimeSheetData = () => {
  return generateTimeSheetData();
};

// You can also export a sample of the data for testing
export const sampleTimeSheetData = generateTimeSheetData();
